import { createFileRoute, redirect } from '@tanstack/react-router'

export const redirectLegacyDomainsIndex = ({ params }: { params: { orgId: number } }) => {
  throw redirect({
    to: '/$orgId/website/domains',
    params: { orgId: params.orgId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/domains/')({
  loader: redirectLegacyDomainsIndex,
})
